import { useState } from 'react';
import { useDispatch } from 'react-redux';
import AccessPodRenderer from '@/components/AccessPodRenderer';
import { useDataEnv } from '@/functions/DataEnv';
import { actions } from '@/store/store';

function AccessFeatureUnlockedView({ accessFeature, accessKey, currentAccount }) {
  const accountPath = Routes.account_path();
  const { site_config } = useDataEnv();
  const folio = accessFeature.folio;
  const [current, setCurrent] = useState(folio?.[0]);
  const dispatch = useDispatch();
  const [accessKeyMessage, setAccessKeyMessage] = useState('');

  const getPodIcon = (renderer) => {
    switch(renderer) {
      case 'image': {
        return 'fa-image';
      }
      case 'md': {
        return 'fa-align-justify';
      }
      case 'pdf': {
        return 'fa-file';
      }
      case 'component': {
        return 'fa-lightbulb';
      }
      case 'video': {
        return 'fa-video';
      }
      default: {
        return 'fa-play';
      }
    }
  };

  const navigateToPod = (pod) => {
    setCurrent(pod);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const accessKeyCanBeClaimed = !accessKey?.account_id && !!currentAccount;

  const claimAccessKey = async () => {
    dispatch(actions.accessKeys.claim({ id: accessKey.code }));
  };

  return (
    <>
      <div className="d-flex align-items-start mb-4 pb-3 border-bottom">
        <div style={{width: '80px', marginRight: '1rem'}}>
          <img
            src={accessFeature.image_227x303}
            alt={accessFeature.name}
            className="img-fluid rounded"
            style={{aspectRatio: '227/303', objectFit: 'cover'}}
          />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center mb-1">
            <span className="badge bg-success me-2">
              <i className="fas fa-check me-1"></i>
              UNLOCKED
            </span>
          </div>
          <h4 className="mb-1">{accessFeature.title}</h4>
          <p className="text-muted mb-0 small">{accessFeature.description}</p>
        </div>
      </div>

      {!folio && (
        <>
          <h3>{accessFeature.title}</h3>
          <p>
            {accessFeature.title} is currently in presales.
            Your early interest is recorded, and you'll receive an an email when this product is released!
          </p>
          <p>Here's a quick checklist of what to do to ensure you receive up-to-date information:</p>
          <ul>
            <li><a href={accountPath}>Make an Account</a></li>
            <li><a href={accountPath}>Claim this Access Key at the Account dashboard</a></li>
          </ul>
          <p>Stay tuned,<br/>Site owners at {site_config.site_name}.</p>
        </>
      )}

      {folio && (
        <div className="row">
          <div className="col-lg-8 mb-4">
            <AccessPodRenderer podule={current}/>
          </div>

          <div className="col-lg-4">
            <div className="list-group sticky-lg-top-offset">
              <>
                {accessKeyCanBeClaimed && (
                  <button onClick={claimAccessKey} className="btn site-btn btn-round mb-3">
                    Claim Key <span className="text-nowrap d-inline-block">{accessKey?.code}</span> for unlimited access.
                  </button>
                )}
                {!currentAccount && (
                  <a href={accountPath} className="btn site-btn btn-round mb-3">
                    Make an Account for unlimited access to <span className="text-nowrap d-inline-block">{accessFeature.name}</span>.
                  </a>
                )}
                {accessKeyMessage && (<div className="access-key-message mb-3">{accessKeyMessage}</div>)}
                <div className="content-list-group">
                  {folio.map((pod, index) => (
                    <button
                      key={pod.id}
                      type="button"
                      className={`list-group-item list-group-item-action ${current.id === pod.id ? 'active' : ''}`}
                      onClick={() => navigateToPod(pod)}
                    >
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <div
                            className={`rounded-circle ${current.id === pod.id ? 'bg-white bg-opacity-25' : 'bg-light'} d-flex align-items-center justify-content-center`}
                            style={{width: '40px', height: '40px', minWidth: '40px'}}
                          >
                            {current.id === pod.id ? (
                              <i className={["fas text-white", getPodIcon(pod.renderer)].join(' ')}></i>
                            ) : (
                              <small className="text-muted">{index + 1}</small>
                            )}
                          </div>
                        </div>
                        <div className="flex-grow-1" style={{minWidth: 0}}>
                          <div className="fw-medium mb-1">{pod.name}</div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AccessFeatureUnlockedView;